<template>
  <div></div>
</template>

<script setup>
import { watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import bgm from '@/assets/imgs/act/mwr/bgm.mp3'

const route = useRoute()

// 使用全局音频实例，避免被 Vue 响应式系统影响
const getGlobalAudio = () => {
  if (!window.__mwr2025_audio__) {
    const audio = document.createElement('audio')
    audio.src = bgm
    audio.loop = true
    audio.preload = 'auto'
    audio.style.display = 'none'
    // 将音频元素添加到 body，避免被 Vue 响应式系统影响
    document.body.appendChild(audio)
    window.__mwr2025_audio__ = audio
  }
  return window.__mwr2025_audio__
}

// 初始化音频播放
const initAudio = () => {
  const audio = getGlobalAudio()
  
  // 检查是否已经播放过
  const hasStarted = sessionStorage.getItem('mwr2025_audio_started') === 'true'
  
  if (hasStarted) {
    // 如果已经播放过，确保继续播放（如果被暂停了）
    if (audio.paused) {
      audio.play().catch(() => {
        // 静默处理错误
      })
    }
  } else {
    // 只有在未播放过时才播放
    audio.play().catch(err => {
      // 处理自动播放被阻止的情况
      console.log('音频自动播放被阻止:', err)
    })
    sessionStorage.setItem('mwr2025_audio_started', 'true')
  }
}

// 控制音频播放，避免切换页面时重新播放
onMounted(() => {
  initAudio()
  
  // 监听路由变化，确保切换子路由时音频继续播放
  watch(() => route.path, () => {
    nextTick(() => {
      const audio = getGlobalAudio()
      const hasStarted = sessionStorage.getItem('mwr2025_audio_started') === 'true'
      if (hasStarted && audio.paused) {
        // 如果音频被暂停，恢复播放
        audio.play().catch(() => {
          // 静默处理错误
        })
      }
    })
  })
  
  // 监听页面可见性变化，实现后台暂停、前台继续播放
  const handleVisibilityChange = () => {
    const audio = getGlobalAudio()
    const hasStarted = sessionStorage.getItem('mwr2025_audio_started') === 'true'
    
    if (!hasStarted) return
    
    if (document.hidden) {
      // 页面进入后台，暂停音频
      if (!audio.paused) {
        audio.pause()
      }
    } else {
      // 页面返回前台，继续播放
      if (audio.paused) {
        audio.play().catch(() => {
          // 静默处理错误
        })
      }
    }
  }
  
  // 添加页面可见性监听
  document.addEventListener('visibilitychange', handleVisibilityChange)
  
  // 保存清理函数，用于组件卸载时移除监听
  window.__mwr2025_visibility_handler__ = handleVisibilityChange
})

// 组件卸载时清理
onBeforeUnmount(() => {
  // 移除页面可见性监听
  if (window.__mwr2025_visibility_handler__) {
    document.removeEventListener('visibilitychange', window.__mwr2025_visibility_handler__)
    window.__mwr2025_visibility_handler__ = null
  }
})
</script>
